import { ApiCall } from "../../utils/index";

export const updateWorkingHours = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.post(`/company/settings/workinghours`, payload, token);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const getWorkingHours = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get(`/company/settings/workinghours`, token);
    request.onSuccess(result);
  } catch (error) {
    request.onError(error);
  }
};

